import { render } from "./DiffCommitSelector.vue?vue&type=template&id=5618b79f&scoped=true&ts=true"
import script from "./DiffCommitSelector.vue?vue&type=script&lang=ts"
export * from "./DiffCommitSelector.vue?vue&type=script&lang=ts"

import "./DiffCommitSelector.vue?vue&type=style&index=0&id=5618b79f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5618b79f"]])

export default __exports__